// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewSelectStyles } from "@turnerBlueprint/Overrides/Widgets/ProductList/ProductListViewSelect";
import IconPlpGrid from "@turnerBlueprint/XDL/Icons/IconPlpGrid";
import IconPlpList from "@turnerBlueprint/XDL/Icons/IconPlpList";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        algin-items: center;
        gap: 8px;
    `,
};

viewSelectStyles.listViewIcon = {
    src: IconPlpList,
    size: 20,
};

viewSelectStyles.gridViewIcon = {
    src: IconPlpGrid,
    size: 20,
};

viewSelectStyles.listViewClickable = {
    css: css`
        margin-right: 4px;
    `,
};
viewSelectStyles.gridViewClickable = {};

viewSelectStyles.title = {
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};
